import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import bcrypt from "bcryptjs";
import { Image, message } from "antd";
import {
  UserOutlined,
  LockOutlined,
  UnlockOutlined,
  CloseOutlined,
  CloseCircleFilled,
} from "@ant-design/icons";
// import "../../Login/Login.css";
import "../../../GlobalCss/SPF/Login.css";
import { useHistory } from "react-router-dom";
import { ActivePage } from "../../../Components/SideBar/Sidebar";
import { encodeRoute, InfoMessage, routes } from "../../../Utils/Utils";
import { BaseUrl, JsonConfig } from "../../../Repository/BaseRepository";
const Login = () => {
  const { id } = useParams()
  useEffect(() => {
    callTenantAPI()
  }, [])
  const callTenantAPI = async () => {
    try {
      const res = await postTenantData(id);
    }
    catch {

    }
  }
  const postTenantData = async (name) => {
    try {
      console.log("inside: getTenantDataFE")
      console.log(name)
      Cookies.remove("jwt_token");
        Cookies.remove("UserLogin");
        Cookies.remove("first_name");
        Cookies.remove("last_name");
        Cookies.remove("Role");
        Cookies.remove("Date");
      let url = `${BaseUrl}Tenant/GetTenantName?tenant=${name}`;
      console.log(url)
      const res = await axios.get(url, JsonConfig)
      console.log(res)
      Cookies.set("tenant_name", name);
      return res;
    }
    catch {

    }
  }
  const location = useLocation();
  const { logoutMsg } = location.state ? location.state : "no";
  const [showSignup, setShowsignup] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [result, setResult] = useState("");
  const [showSubmitError, setSubmitError] = useState(false);
  const [showNetworkError, setShowNetworkError] = useState(false);
  const [mailPassError, setMailPassError] = useState(false);
  const [errorMsg] = useState("Enter correct credentials");
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(
    <LockOutlined style={{ color: "blue" }}></LockOutlined>
  );
  const [showSpinner, setShowSpinner] = useState(false);
  const [showLogoutDiv, setShowLogoutDiv] = useState(false);
  const currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + 6);
  const history = useHistory();
  const ChangeEmail = (event) => {
    setSubmitError(false);
    setShowNetworkError(false);
    setMailPassError(false);
    setEmail(event.target.value);
  };
  const ChangePassword = (event) => {
    setSubmitError(false);
    setShowNetworkError(false);
    setMailPassError(false);
    setPassword(event.target.value);
  };

  const handleIcon = () => {
    if (type === "password") {
      setType("text");
      setIcon(<UnlockOutlined style={{ color: "blue" }}></UnlockOutlined>);
    } else {
      setType("password");
      setIcon(<LockOutlined style={{ color: "blue" }}></LockOutlined>);
    }
  };

  const submitForm = (event) => {
    event.preventDefault();
    setSubmitError(false);
    setMailPassError(false);
    setShowNetworkError(false);
    setShowLogoutDiv(false);

    if (email.length === 0 || password.length === 0) {
      setMailPassError(true);
      setShowSpinner(false);
    } else {
      setShowSpinner(true);
      const hashedPassword = bcrypt.hashSync(password, 10);

      axios
        .post(`${process.env.REACT_APP_BASE_URL}Auth/sign-in`, {
          email,
          hashedPassword,
        })
        .then((response) => {
          console.log("Response data:", response.data);
          const { data } = response;
          let payload = {};
          if (data.payload) {
            payload = JSON.parse(data.payload);
          }

          if (data.statusCode === 200) {
            const responseData = JSON.parse(data.payload);
            console.log(responseData)
            // Cookies.set("jwt_token", responseData.Token);
            // Cookies.set("first_name", responseData.FirstName);
            // Cookies.set("last_name", responseData.LastName);
            // Cookies.set("UserLogin", responseData.Email);
            // Cookies.set("Role", responseData.Role);
            //history.replace("/dashboard");
            if (
              responseData.hasOwnProperty("Role") &&
              responseData.Role === "Automated User"
            ) {
              InfoMessage(`${email} has limited access, try with another user`);
              setShowSpinner(false);
            } else {
              Cookies.set("email", email);              
              Cookies.set("authKey", payload.authKey);
              // history.replace(`/${id}/${routes.sendOtp}`);
              history.replace(`/${id}/sendotp`);
              console.log("redirecting to "+`/${id}/${routes.sendOtp}` )

              // message.success("User Authenticated");
            }
          } else {
            if (
              data.statusCode === 401 &&
              data.message === "Invalid Credentials"
            ) {
              setSubmitError(true);
            } else {
              message.error(data.message);
            }
            setShowSpinner(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setShowSpinner(false);
          setShowNetworkError(true);
        });
    }
  };



  useEffect(() => {
    if (logoutMsg === "yes") {
      setShowLogoutDiv(true);
    }
    const jwtToken = Cookies.get("jwt_token");
    const userRole = Cookies.get("Role");
    const reqRole = "Super User";
    if (jwtToken !== undefined && userRole === reqRole) {
     
      // history.replace(`/${id}/${routes.adminDashboard}`);
      history.replace(`/${id}/admin-dashboard`);

      // window.location.href = "/admin-dashboard";
    } else if (jwtToken !== undefined && userRole === "User") {
 
      // history.replace(`/${id}/${routes.dashboard}`);
      history.replace(`/${id}/dashboard`);
    }

  }, []);
  const goToResetPage = () => {
    window.location.href = "/resetpassword";
  };

  return (
    <>
      <div className="fullscreen">
        <div className="login-col">
          {showLogoutDiv && (
            <div className="logout-msg-class">
              <span className="logout-msg">
                You've successfully logged out!
              </span>
              <span className="logout-close">
                <CloseCircleFilled
                  style={{ marginTop: 5, cursor: "pointer" }}
                  onClick={() => setShowLogoutDiv(false)}
                />
              </span>
            </div>
          )}
          <div className="form-border">
            {showSpinner && (
              <marquee
                width="100%"
                direction="right"
                scrollamount="40"
                className="progress"
              >
                <div className="marquee-div"> </div>
              </marquee>
            )}
            <div className={showSpinner ? "blur-form" : "form-div"}>
              <div className="card-title">
                <Image
                  src="/Images/LogoMain.jpg"
                  style={{
                    border: "none",
                    width: "50% ",
                  
                  }}
                  showPreviewIcon={false}
                  preview={false}
                />
              </div>
              <form className="Loginform-class" onSubmit={(e) => submitForm(e)}>
                <div className="login-signup">
                  <span style={{ marginLeft: 5 }}>
                    <UserOutlined style={{ color: "blue" }}></UserOutlined>
                  </span>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter your Email"
                    className="email-class"
                    value={email}
                    onChange={(e) => ChangeEmail(e)}
                  />
                </div>
                <div className="login-signup">
                  <span style={{ marginLeft: 5 }} onClick={handleIcon}>
                    {icon}
                  </span>
                  <input
                    type={type}
                    id="password"
                    placeholder="Enter your Password"
                    className="email-class"
                    onChange={(e) => ChangePassword(e)}
                  />
                </div>
                {showSubmitError && (
                  <div className="row-three" style={{ color: "#FF0000" }}>
                    <p style={{ color: "#FF0000" }}>*Invalid Credentials</p>
                  </div>
                )}
                {mailPassError && (
                  <div className="row-three" style={{ color: "#FF0000" }}>
                    <p style={{ color: "#FF0000" }}>
                      *Email/ Password should not be empty
                    </p>
                  </div>
                )}
                {showNetworkError && (
                  <div className="row-three" style={{ color: "#FF0000" }}>
                    <p style={{ color: "#FF0000" }}>
                      Please check your newtork
                    </p>
                  </div>
                )}
                <div className="row-four">
                  <div className="forgot-remember">
                    <div className="checkclass">
                      {/* <input type="checkbox" className="checkme" /> */}
                      &nbsp;
                      {/* <span className="checkmark">Remember me</span> */}
                    </div>
                    <div className="checkclass">
                      <Link
                        to={{ pathname: "/reset" }}
                        className="forgot-button"
                      >
                        Forgot Password ?
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="row-five">
                  <button
                    type="submit"
                    className={showSpinner ? "signin-blur" : "signin-button"}
                  >
                    Sign In
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* <div className="space-col"></div> */}
        <div className="image-fullcol">
          <Image
            src="/Images/7566.jpg"
            style={{
              border: "none",
              width: "80% ",
              // paddingTop: 120,
              // margin:"auto",
              height: "110%",
            }}
            showPreviewIcon={false}
            preview={false}
          />
        </div>
      </div>
    </>
  );
};
export default Login;
